import { atom } from "recoil";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";

export type AlarmType = {
  is_available: boolean;
  time: Date | null;
  effect: string;
  count?: number;
  gap?: number;
};

export const alarmState = atom<AlarmType>({
  key: "alarm",
  default: {
    is_available: false,
    time: null,
    effect: "",
  },
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem("alarm");

      if (savedAuthData) setSelf(savedAuthData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("alarm")
          : AsyncLocalStorage.setItem("alarm", JSON.stringify(newValue));
      });
    },
  ],
});
